import React from "react";
import styled from "styled-components";
import { AddCircleOutline } from "@mui/icons-material";
import TooltipIconButton from "components/TooltipIconButton";

const Wrapper = styled.article`  
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: ${props => props.bg ? `linear-gradient(180deg, rgba(47, 47, 47, 0) 0%, rgba(35, 35, 35, 0.79) 98.96%), url(` + props.bg + `)` : ""};

  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: calc(50% - 1rem);
  height: 16rem;
  font-size: ${({ theme }) => theme.font.size.text.small};
  margin: 1rem 0;
  padding: 1.25rem;
  background-color: ${({ theme }) => theme.backgroundColor.tile.default};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  transition: background 0.35s;
  &:nth-of-type(odd) {
    margin-right: 2rem;
  }
  &:hover {
    cursor: pointer;
    background: ${props => !props.bg ? ({ theme }) => theme.backgroundColor.tile.hover : ''};
    background-image: ${props => props.bg ? `linear-gradient(180deg, rgba(47, 47, 47, 0) 0%, rgb(10, 10, 10) 98.96%), url(` + props.bg + `)` : ""};
  }
  strong {
    display: block;
    width: 100%;
    margin: 0 0 0.25rem;
    font-family: Roboto;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #E5E5E5;
  }

  .category {
    font-family: Open Sans;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #C4C4C4;
  }
`;

const Tile = ({ children, title, onAdd, bg, setMapTheme }) => (
  <Wrapper onClick={() => setMapTheme ? setMapTheme(title) : null} bg={bg}>
    <strong>{title}</strong>
    {children}
    {onAdd ? (
      <TooltipIconButton title="Upload Files" ariaLabel="upload-files" placement="top" size={44} position="true" right={1} bottom={-1} onClick={onAdd}>
        <AddCircleOutline />
      </TooltipIconButton>
    ) : (
      <></>
    )}
  </Wrapper>
);

export default Tile;
